import { useEffect, useRef, useState } from 'react';
import { Message } from './useLangflowChat';

export const useScroll = (messages: Message[]) => {
  const [hasScrollbar, setHasScrollbar] = useState(false);

  const messagesContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkScrollbar = () => {
      if (messagesContainerRef.current) {
        const hasScroll =
          messagesContainerRef.current.scrollHeight > messagesContainerRef.current.clientHeight;
        setHasScrollbar(hasScroll);
      }
    };
    checkScrollbar();
    const observer = new ResizeObserver(checkScrollbar);
    if (messagesContainerRef.current) {
      observer.observe(messagesContainerRef.current);
    }

    return () => observer.disconnect();
  }, [messages]);

  return { hasScrollbar, messagesContainerRef };
};
